import { Provider } from "react-redux";
import MainRoutes from "./routes";
import { store } from "./redux/storeOf";
import "./App.css";
import { useAxiosSessionInterceptor } from "./utils/useAxiosSessionInterceptor";
import AuthBootstrap from "./components/AuthBootstrap";
import SessionKeepAlive from "./components/SessionKeepAlive";

function App() {
  useAxiosSessionInterceptor();

  return (
    <Provider store={store}>
      <AuthBootstrap>
        <SessionKeepAlive />
        <MainRoutes />
      </AuthBootstrap>
    </Provider>
  );
}

export default App;
